import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import "../../styles/SeasonPage.css"

const BIO_MAX = 300;

const SeasonPage = ({ dark, setDark, sidebarOpen, setSidebarOpen }) => {
    const { id } = useParams(); // id de la saison (ex : /garden/season/1)
    const [cookies] = useCookies(["token"]);
    const toggleTheme = () => setDark(!dark);

    const [season, setSeason] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showSemisDrawer, setShowSemisDrawer] = useState(false);

    const [semisPlant, setSemisPlant] = useState("");
    const [semisDateSemis, setSemisDateSemis] = useState("");
    const [semisNotes, setSemisNotes] = useState("");

    const [showEditSemisDrawer, setShowEditSemisDrawer] = useState(false);
    const [editSemisId, setEditSemisId] = useState(null);
    const [editDateRempotage, setEditDateRempotage] = useState("");
    const [editDatePot, setEditDatePot] = useState("");
    const [editDateWatering, setEditDateWatering] = useState("");

    const [editField, setEditField] = useState(null);

    const [photoPreview, setPhotoPreview] = useState(null);
    const [showPhotoDrawer, setShowPhotoDrawer] = useState(false);
    const [photoFile, setPhotoFile] = useState(null);

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);


    const [selectedTags, setSelectedTags] = useState([]);
    const availableTags = [
        { id: "meteo", label: "🌡️ Météo" },
        { id: "arrosage", label: "💧 Arrosage" },
        { id: "parasites", label: "🐛 Parasites" },
        { id: "croissance", label: "🌱 Croissance" },
        { id: "recolte", label: "🍅 Récolte" },
        { id: "plantation", label: "🌾 Plantation"}
    ];



    const [showNoteDrawer, setShowNoteDrawer] = useState(false);
    const [noteText, setNoteText] = useState("");


    // Charger la saison + notes
    const fetchSeason = async () => {
        try {
            const res = await fetch(`https://api.industriegaming.fr/api/garden/season/${id}`, {
                headers: {
                    Authorization: `Bearer ${cookies.token}`,
                },
            });
            const data = await res.json();
            setSeason(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const toggleTag = (tagId) => {
        setSelectedTags(prev =>
            prev.includes(tagId)
                ? prev.filter(t => t !== tagId)
                : [...prev, tagId]
        );
    };


    const uploadPhoto = async () => {
        if (!photoFile) return;
        console.log(photoFile);

        const formData = new FormData();
        formData.append("photo", photoFile);

        try {
            await fetch(`https://api.industriegaming.fr/api/garden/season/${id}/photo`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: formData,
            });

            setShowPhotoDrawer(false);
            setPhotoFile(null);
            fetchSeason(); // recharge les photos
        } catch (err) {
            console.error(err);
        }
    };


    // const openEditSemisDrawer = (semis) => {
    //     setEditSemisId(semis.id);
    //     setEditDateRempotage(semis.dateRempotage ? semis.dateRempotage.split("T")[0] : "");
    //     setShowEditSemisDrawer(true);
    // };

    const openEditSemisDrawer = (semis, field) => {
        setEditSemisId(semis.id);
        setEditField(field);

        if (field === "rempotage") {
            setEditDateRempotage(semis.dateRempotage ? semis.dateRempotage.split("T")[0] : "");
        }

        if (field === "pot") {
            setEditDatePot(semis.datePot ? semis.datePot.split("T")[0] : "");
        }

        setShowEditSemisDrawer(true);
    };


    const saveEditSemis = async () => {
        try {
            const body = {};

            if (editField === "rempotage") {
                body.dateRempotage = editDateRempotage;
            }

            if (editField === "pot") {
                body.datePot = editDatePot;
            }

            if (editField === "watering") {
                body.dateWatering = editDateWatering;
            }

            await fetch(`https://api.industriegaming.fr/api/garden/semis/${editSemisId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify(body),
            });

            setShowEditSemisDrawer(false);
            setEditSemisId(null);
            setEditField(null);
            setEditDateRempotage("");
            setEditDatePot("");

            fetchSeason(); // recharge la saison
        } catch (err) {
            console.error(err);
        }
    };

    const isArchived = season?.archived;

    const toggleCancelSemis = async (semis, value) => {
        if (!window.confirm(value ? `Confirmer l'annulation du semis "${semis.plant}" ?` : `Reactiver le semis "${semis.plant}" ?`)) return;
        try {
            await fetch(`https://api.industriegaming.fr/api/garden/semis/${semis.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify({ cancelled: value }),
            });

            fetchSeason();
        } catch (err) {
            console.error(err);
        }
    };

    const saveSemis = async () => {
        try {
            await fetch(`https://api.industriegaming.fr/api/garden/season/${id}/semis`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify({
                    plant: semisPlant,
                    dateSemis: semisDateSemis,
                    notes: semisNotes
                }),
            });

            setShowSemisDrawer(false);
            setSemisPlant("");
            setSemisDateSemis("");
            setSemisNotes("");

            fetchSeason();
        } catch (err) {
            console.error(err);
        }
    };



    useEffect(() => {
        fetchSeason();
    }, [id]);

    const openNoteDrawer = () => {
        setNoteText("");
        setShowNoteDrawer(true);
    };

    const closeNoteDrawer = () => {
        setShowNoteDrawer(false);
    };

    const toggleImportant = async (note) => {
        try {
            await fetch(`https://api.industriegaming.fr/api/garden/note/${note.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify({
                    important: !note.important
                }),
            });

            fetchSeason(); // recharge les notes
        } catch (err) {
            console.error(err);
        }
    };


    const saveNote = async () => {
        if (!noteText.trim()) return;
        try {
            await fetch(`https://api.industriegaming.fr/api/garden/season/${id}/note`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`,
                },
                body: JSON.stringify({
                    content: noteText,
                    tags: selectedTags
                })
            });

            setShowNoteDrawer(false);
            setNoteText("");
            fetchSeason(); // recharger les notes
        } catch (err) {
            console.error(err);
        }
    };

    if (loading || !season) {
        return (
            <div className={`dashboard ${dark ? "dark" : ""}`}>
                <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                <div className="main">
                    <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />
                    <div className="season-page">
                        <p>Chargement...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark}/>

                <div className="season-page">

                    {/* HEADER */}
                    <div className="season-header">
                        <h1>Saison {season?.year}</h1>


                        <div className="season-header-actions">
                            {user?.role === "Admin" && (
                                <button disabled={isArchived} className="add-user-btn" onClick={() => setShowSemisDrawer(true)}>
                                    + Ajouter un semis
                                </button>
                            )}
                            {user?.role === "Admin" && (
                                <button disabled={isArchived} className="add-user-btn" onClick={() => setShowPhotoDrawer(true)}>
                                    + Ajouter une photo
                                </button>
                            )}

                            {user?.role === "Admin" && (
                                <button disabled={isArchived} className="add-user-btn" onClick={openNoteDrawer}>
                                    + Ajouter une note
                                </button>
                            )}
                        </div>

                    </div>

                    {isArchived && (
                        <div className="archived-banner">
                            Cette saison est archivée.
                            Vous pouvez toujours consulter les données, mais plus les modifier.
                        </div>
                    )}

                    {/* SEMIS */}
                    <div className="semis-section">
                        <h2>Semis</h2>

                        {season?.GardenSemis?.length === 0 && (
                            <p>Aucun semis pour cette saison.</p>
                        )}

                        {season?.GardenSemis?.map((semis) => (
                            <div key={semis.id} className={`semis-card ${semis.cancelled ? "cancelled" : ""}`}>
                                {user?.role === "Admin" && !isArchived && (
                                    <button
                                        className={`cancel-icon-btn ${semis.cancelled ? "reactivate" : "cancel"}`}
                                        onClick={() => toggleCancelSemis(semis, !semis.cancelled)}
                                        title={semis.cancelled ? "Réactiver le semis" : "Annuler le semis"}
                                    >
                                        <i className={semis.cancelled ? "fa fa-undo" : "fa fa-times"} aria-hidden="true"></i>
                                    </button>
                                )}

                                <p><strong>Plante :</strong> {semis.plant}</p>
                                <p><strong>Date semis :</strong> {new Date(semis.dateSemis).toLocaleDateString("fr-FR")}
                                </p>
                                {/*<p><strong>Date rempotage*/}
                                {/*    :</strong> {semis.dateRempotage ? new Date(semis.dateRempotage).toLocaleDateString("fr-FR") : "Pas encore rempoté"}*/}
                                {/*</p>*/}
                                <p>
                                    <strong>Rempotage :</strong>{" "}
                                    {semis.dateRempotage ? (
                                        new Date(semis.dateRempotage).toLocaleDateString("fr-FR")
                                    ) : (
                                        <>
                                            <span style={{opacity: 0.6}}>Pas encore rempoté</span>
                                            {user?.role === "Admin" && !semis.cancelled && (
                                                <span
                                                    className={`edit-semis-icon ${isArchived ? "disabled" : ""}`}
                                                    onClick={() => openEditSemisDrawer(semis, "rempotage")}
                                                >
                                                ✏️
                                                </span>
                                            )}
                                        </>
                                    )}
                                </p>
                                {/* DATE POT (mise en pot) */}
                                <p>
                                    <strong>Mise en pot :</strong>{" "}
                                    {semis.datePot ? (
                                        new Date(semis.datePot).toLocaleDateString("fr-FR")
                                    ) : (
                                        <>
                                            <span style={{opacity: 0.6}}>Pas encore mis en pot</span>
                                            {user?.role === "Admin" && !semis.cancelled && (
                                                <span
                                                    className={`edit-semis-icon ${isArchived ? "disabled" : ""}`}
                                                    onClick={() => openEditSemisDrawer(semis, "pot")}
                                                >
                                                ✏️
                                                </span>
                                            )}
                                        </>
                                    )}
                                </p>
                                <p>
                                    <strong>Dernier arrosage :</strong>{" "}
                                    {semis.lastWatering ? (
                                        new Date(semis.lastWatering).toLocaleDateString("fr-FR")
                                    ) : (
                                        <>
                                            <span style={{opacity: 0.6}}>Jamais</span>
                                        </>
                                    )}

                                    {/* Bouton d’édition (Admin uniquement + pas archivé) */}
                                    {user?.role === "Admin" && !isArchived && !semis.cancelled && (
                                        <span
                                            className="edit-semis-icon"
                                            onClick={() => openEditSemisDrawer(semis, "watering")}
                                        >
                                            ✏️
                                        </span>
                                    )}
                                </p>

                                <p><strong>Notes :</strong> {semis.notes}</p>
                                {semis.cancelled && (
                                    <div className="cancelled-side-label">Annulé</div>
                                )}
                            </div>
                        ))}
                    </div>


                    {/* NOTES */}
                    <div className="notes-section">
                    <h2>Notes</h2>

                        {season?.GardenNotes?.length === 0 && (
                            <p>Aucune note pour le moment.</p>
                        )}

                        {season?.GardenNotes?.map((note) => (
                            <div
                                key={note.id}
                                className={`note-card ${note.important ? "important-note" : ""}`}
                            >
                                <div className="note-header">
                                    <div className="note-date">
                                        {new Date(note.date).toLocaleDateString("fr-FR")}
                                    </div>

                                    
                                    {/* Icône étoile pour marquer important */}
                                    {user?.role === "Admin" && (
                                    <span
                                        className={`note-important-icon ${note.important ? "active" : ""} ${isArchived ? "disabled" : ""}`}
                                        onClick={() => toggleImportant(note)}
                                    >
                                    ⭐
                                    </span>
                                    )}
                                </div>

                                <div className="note-tags">
                                    {note.tags?.map((tag) => (
                                        <span key={tag} className={`tag-pill tag-${tag}`}>
                                            {availableTags.find(t => t.id === tag)?.label}
                                        </span>
                                    ))}
                                </div>


                                <div className={`note-content ${note.important ? "active" : ""}`}>{note.content}</div>
                            </div>
                        ))}

                    </div>

                    {/* PHOTOS */}
                    <div className="photos-section">
                        <h2>Photos</h2>

                        {season?.GardenPhotos?.length === 0 && (
                            <p>Aucune photo pour cette saison.</p>
                        )}

                        {/*<div className="photos-grid">*/}
                        {/*{season?.GardenPhotos?.map((photo) => (*/}
                        {/*        <img*/}
                        {/*            key={photo.id}*/}
                        {/*            src={photo.url}*/}
                        {/*            alt="Photo jardin"*/}
                        {/*            className="photo-item"*/}
                        {/*            onClick={() => setPhotoPreview(photo.url)}*/}
                        {/*        />*/}
                        {/*    ))}*/}
                        {/*</div>*/}
                        <div className="photos-grid">
                            {season?.GardenPhotos?.map((photo) => (
                                <div
                                    className="photo-wrapper"
                                    key={photo.id}
                                    onClick={() => setPhotoPreview(photo.url)}
                                >
                                    <img
                                        src={photo.url}
                                        alt="Photo jardin"
                                        className="photo-item"
                                    />
                                    <span className="photo-date">
                                        {new Date(photo.date).toLocaleDateString("fr-FR")}
                                    </span>
                                </div>
                            ))}
                        </div>


                    </div>

                </div>
            </div>

            {/* DRAWER AJOUT NOTE */}
            {showNoteDrawer && (
                <div className="drawer-overlay">
                    <div className="drawer">
                        <h2>Ajouter une note</h2>

                        <div className="bio-edit-container animate-bio">
                            <textarea
                                className="bio-textarea"
                                value={noteText}
                                maxLength={300}
                                onChange={(e) => setNoteText(e.target.value)}
                            ></textarea>
                            <div className="bio-counter">
                                {noteText.length}/300
                            </div>
                        </div>
                        <div className="drawer-field">
                            <label>Tags</label>
                            <div className="tags-selector">
                                {availableTags.map(tag => (
                                    <span
                                        key={tag.id}
                                        className={`tag-item ${selectedTags.includes(tag.id) ? "selected" : ""}`}
                                        onClick={() => toggleTag(tag.id)}
                                    >
                                            {tag.label}
                                        </span>
                                ))}
                            </div>
                        </div>


                        <div className="drawer-actions">
                            <button className="edit-glass-btn" onClick={saveNote}>
                                Enregistrer
                            </button>
                            <button className="edit-glass-btn" onClick={closeNoteDrawer}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showSemisDrawer && (
                <div className="drawer-overlay">
                    <div className="drawer">
                        <h2>Ajouter un semis</h2>

                        <div className="drawer-field">
                            <label>Plante</label>
                            <input
                                type="text"
                                value={semisPlant}
                                onChange={(e) => setSemisPlant(e.target.value)}
                            />
                        </div>

                        <div className="drawer-field">
                            <label>Date de semis</label>
                            <input
                                type="date"
                                value={semisDateSemis}
                                onChange={(e) => setSemisDateSemis(e.target.value)}
                            />
                        </div>

                        <div className="drawer-field">
                            <label>Notes</label>
                            <textarea
                                value={semisNotes}
                                onChange={(e) => setSemisNotes(e.target.value)}
                            ></textarea>
                        </div>

                        <div className="drawer-actions">
                            <button className="edit-glass-btn" onClick={saveSemis}>
                                Enregistrer
                            </button>
                            <button className="edit-glass-btn" onClick={() => setShowSemisDrawer(false)}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showEditSemisDrawer && (
                <div className="drawer-overlay">
                    <div className="drawer">
                        <h2>Modifier le semis</h2>

                        <div className="drawer-field">
                            {editField === "rempotage" ? (
                                <label>Date de <span>rempotage</span></label>
                            ) : null}
                            {editField === "pot" ? (
                                <label>Date de <span>mise en pot</span></label>
                            ) : null}
                            {editField === "watering" ? (
                                <label>Date du <span>dernier arrosage</span></label>
                            ) : null}

                            <input
                                type="date"
                                value={editField === "rempotage" ? editDateRempotage : editField === "pot" ? editDatePot : editDateWatering }
                                onChange={(e) => {
                                    if (editField === "rempotage") setEditDateRempotage(e.target.value);
                                    if (editField === "pot") setEditDatePot(e.target.value);
                                    if (editField === "watering") setEditDateWatering(e.target.value);
                                }}
                            />
                        </div>

                        <div className="drawer-actions">
                            <button className="edit-glass-btn" onClick={saveEditSemis}>
                                Enregistrer
                            </button>
                            <button className="edit-glass-btn" onClick={() => setShowEditSemisDrawer(false)}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {photoPreview && (
                <div className="photo-preview-overlay" onClick={() => setPhotoPreview(null)}>
                    <div className="photo-preview-container" onClick={(e) => e.stopPropagation()}>
                        <img src={photoPreview} alt="Agrandissement" className="photo-preview-img" />

                        <button className="photo-preview-close" onClick={() => setPhotoPreview(null)}>
                            ✖️
                        </button>
                    </div>
                </div>
            )}
            {showPhotoDrawer && (
                <div className="drawer-overlay">
                    <div className="drawer">
                        <h2>Ajouter une photo</h2>

                        <div className="drawer-field">
                            <label>Choisir une photo</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => setPhotoFile(e.target.files[0])}
                            />
                        </div>

                        <div className="drawer-actions">
                            <button className="edit-glass-btn" onClick={uploadPhoto}>
                                Envoyer
                            </button>
                            <button className="edit-glass-btn" onClick={() => setShowPhotoDrawer(false)}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>

    );
};

export default SeasonPage;
